import { render, staticRenderFns } from "./PostFeedDrafts.vue?vue&type=template&id=2933f610&"
import script from "./PostFeedDrafts.vue?vue&type=script&lang=js&"
export * from "./PostFeedDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports